import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Box from '@mui/material/Box';
import { translate } from '../i18n/customI18nProvider';

const JsonModal = ({ open, onClose, data, label }) => {

    const [displayData, setDisplayData] = useState(null);

    useEffect(() => {
        if (!data) {
            setDisplayData(null);
            return;
        }

        if (typeof data === 'string') {
            try {
                setDisplayData(JSON.parse(data));
            } catch (e) {
                setDisplayData({ error: "Format JSON invalide", raw: data });
            }
        } else {
            setDisplayData(data);
        }
    }, [data]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{label || "Détails"}</DialogTitle>

            <DialogContent dividers>
                <Box
                    component="pre"
                    sx={{
                        backgroundColor: '#f5f5f5',
                        padding: 2,
                        borderRadius: 1,
                        overflowX: 'auto',
                        fontFamily: 'monospace',
                        fontSize: '0.875rem'
                    }}
                >
                    {JSON.stringify(displayData, null, 2)}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {translate('custom.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default JsonModal;